import { message } from 'antd';
import { ArgsProps } from 'antd/lib/message';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import generateKey from './generateKey';

export const useMessageMutilingual = () => {
  const { t, i18n } = useTranslation();
  const [messageArgsList, setMessageArgsList] = useState<ArgsProps[]>([]);

  useEffect(() => {
    messageArgsList.forEach((args) => {
      message.open({
        ...args,
        content: t(args.content),
        onClose: () => {
          const items = [...messageArgsList];
          items.shift();
          setMessageArgsList([...items]);
        },
      });
    });
    // eslint-disable-next-line
  }, [messageArgsList.length, i18n.language]);

  const messageMulti = {
    error: (content: string, args?: ArgsProps) => {
      setMessageArgsList([...messageArgsList, { ...args, content, key: generateKey(), type: 'error' }]);
    },
    success: (content: string, args?: ArgsProps) => {
      setMessageArgsList([...messageArgsList, { ...args, content, key: generateKey(), type: 'success' }]);
    },
  };

  return { messageMulti };
};
